module.exports = __webpack_public_path__ + "static/img/sm_challenge.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm_challenge.jpg
// module id = AEYr
// module chunks = 0